'use client';

import { Languages } from '@/lib/dictionaries';
import { signIn } from 'next-auth/react';
import Image from 'next/image';

export default function LoginButton({
  lang,
  className,
  provider,
  icon,
}: {
  lang: Languages;
  className: string;
  provider: 'google' | 'apple' | 'line' | 'kakao';
  icon: any;
}) {
  const handleSocialLogin = async () => {
    const result = await signIn(provider, { callbackUrl: `/${lang}` });
    if (result?.error) {
      console.error(`${provider} login error: `, result.error);
    }
  };
  return (
    <button
      onClick={handleSocialLogin}
      className={className}
      id={`login-button-${provider}`}
    >
      <Image src={icon} alt={provider} />
    </button>
  );
}
